import * as React from 'react';
import { sortData } from '../../../utils';
// import { Head } from './Head';
import { Loading } from './Loading';
import cx from 'classnames';
import { IPaginationMeta } from '../../../@types';
import Empty from './Empty';
import { useInView } from 'react-intersection-observer';
import { FloatingScrollButton } from '../../FloatingScrollButton';
import { Filter } from '../../../@types/invoice';
import MediaQuery from 'react-responsive';
import CardList from './MobileTableComponent/CardList';
import { MobileHead } from './MobileHead.';
import { Head } from './Head';

export type HeadingType = {
  /**
   * Title show on the column head.
   */
  title?: string;
  /**
   * Icon show on the column head.
   */
  icon?: any;
  /**
   * Callback function after the title/icon is clicked.
   * @returns void
   */
  onClick?: () => void;
};

type PaginationProps = {
  /**
   * Show the table footer pagination.
   * The meta prop and fetchMore Data prop will be required
   */
  showPagination?: true;
  /**
   * Pagination meta data
   */
  meta?: IPaginationMeta;
  /**
   * Fetch more data for pagination
   * @param offset The point to start fetching data.
   * @param limit Max number of data to fetch.
   * @param cursor Last data id.
   * @returns Void
   */
  fetchMoreData?: (direction: 'up' | 'down') => void;
};

type HeadProps =
  | {
      showHead?: false;
      buttons?: never;
      handleSearch?: never;
    }
  | {
      /**
       * Show the table head components.
       * @type boolean
       */
      showHead?: true;

      /**
       * List of grouped buttons to show in the head component
       */
      buttons: Array<{
        text: string;
        icon: any;
        href?: string;
        onClick?: () => void;
      }>;
      /**
       * Function called when search text changes.
       * @param text search text
       * @returns void
       */
      handleSearch?: (text: string) => void;
      handleSort?: (text: string) => void;
      selectedFilter?: any;
      handleFilter?: (filter: Filter) => void;
      searchResult: any[];
      searchDisplayKey: string;
      searchPlaceHolder: string;
      handleSearchSelect?: (item: any) => void;
      showMobileInvoiceTable?: boolean;
    };
export type TableItem = {
  [key: string]:
    | string
    | number
    | boolean
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | React.ReactFragment
    | React.ReactPortal
    | null
    | undefined;
};

export type TableData = {
  data: [];
};
type ItemProps<T> = {
  /**
   * A HeadingType Object displayed in the table header.
   * The key of this object will be used as key for the items displayed on the table data.
   */
  head: T;
  /**
   * Array of object with keys of HeadingType as it's key.
   * Determines the data that will be rendered in the body of the table
   */
  data: Array<{ [key in keyof T]: any }>;
} & PaginationProps &
  HeadProps;

export type TableProps<T> = {
  /**
   * Indicates whether table data is loading or not.
   */
  isLoading: boolean;
  hideFloatingScrollButton?: boolean;
  showMobileInvoiceTable?: boolean | undefined | any;
  CustomerCard?: boolean | any;
  expenseCard?: boolean | undefined;
  invoiceCard?: boolean | undefined;
  payHistoryTable?: boolean;
} & ItemProps<T>;

const DesktopTableBody = ({
  data,
  head,
  isLoading,
  showPagination,
}: {
  data: TableItem[];
  head: { title?: string; icon?: any };
  isLoading: boolean;
  showPagination: boolean;
}) => (
  <>
    {isLoading ? (
      <Loading data={head} />
    ) : (
      data.map((data, i) => (
        <tr
        key={i}
        className={cx({
          'bg-white dark:border-gray-700 dark:bg-gray-800 w-full flex justify-between': i % 2 === 0,
          'bg-[#044E97] bg-opacity-10 dark:border-gray-700 dark:bg-gray-800 w-full flex justify-between': i % 2 !== 0,
        })}
      >
        {Object.keys(head).map((head, ind) => (
          <td
            key={ind}
            className="text-[14px] font-medium text-gray-900 dark:text-white w-full py-8 xl:pl-[50px] 2xl:pl-[50px] 3xl:pl-[50px] 4xl:pl-[50px] biglg:pl-[30px] lg:pl-[10px] md:pl-[5px] bigmd:pl-[5px] md:whitespace-normal lg:whitespace-nowrap overflow-hidden overflow-ellipsis"
          >
            {data[head]}
          </td>
        ))}
      </tr>
      
      ))
    )}
    {showPagination && (
      <tr>
        <td colSpan={Object.keys(head).length}></td>
      </tr>
    )}
  </>
);
const MobileTableBody = ({
  data,
  head,
  isLoading,
  showMobileInvoiceTable,
  CustomerCard,
  expenseCard,
  invoiceCard,
  payHistoryTable,
}: {
  data: TableItem[] | any;
  head: { [head: string]: HeadingType };
  isLoading: boolean;
  showMobileInvoiceTable: true;
  CustomerCard: boolean;
  expenseCard: boolean | undefined;
  invoiceCard: boolean | undefined;
  payHistoryTable: boolean | undefined;
}) => (
  <>
    {showMobileInvoiceTable ? (
      <tbody className="table  grid grid-cols-1 border-1">
        <tr className="flex justify-between ">
          <td className="px-[1em]">
            <span className="text-black text-[12px] font-normal">{head['name'].title}</span>
          </td>
          <td className="px-[1em]">
            <span className="text-black text-[12px] font-normal">{head['quantity'].title}</span>
          </td>
          <td className="px-[1em]">
            <span className="text-black text-[12px] font-normal">{head['amount'].title}</span>
          </td>
        </tr>
        {Object.entries(data).map((key: any, i) => {
          return (
            <>
              <tr key={i} className="flex justify-between">
                <td className="px-[1em]">
                  <span className="font-light text-[#000000] not-italic  text-[11px] placeholder:#cccleading-6">
                    {key[1].name}
                  </span>
                </td>
                <td className="">
                  <span className="font-light text-[#000000] not-italic  text-[11px] leading-6">{key[1].quantity}</span>
                </td>
                <td className="px-[1em]">
                  <span className="font-light text-[#000000] not-italic   text-[11px] leading-6">{key[1].amount}</span>
                </td>
              </tr>
            </>
          );
        })}
      </tbody>
    ) : (
      <tbody className="table w-[350px] grid grid-cols-1 gap-1 place-content-center place-items-center">
        {isLoading ? (
          <div className="flex justify-center items-center">
            <Loading data={data} />
          </div>
        ) : (
          <tr>
            <td className="">
              <CardList
                    payHistoryCard={payHistoryTable}
                    CustomerCard={CustomerCard}
                    expenseCard={expenseCard}
                    invoiceCard={invoiceCard}
                    data={data}
                    fetchMoreData={() => {
                      throw new Error('Function not implemented.');
                    } } inventoryCard={undefined}              />
            </td>
          </tr>
        )}
      </tbody>
    )}
  </>
);

const Table = <T extends { [key: string]: HeadingType }>(props: TableProps<T>) => {
  const [data, setData] = React.useState<typeof props.data>([]);
  const [sort, setSort] = React.useState<{
    column: string;
    direction: 'ASC' | 'DESC';
  }>({ column: '', direction: 'DESC' });

  const fetchPageData = (direction: 'up' | 'down') => {
    if (direction === 'down' && props?.meta?.hasMoreData) {
      props.fetchMoreData ? props.fetchMoreData('down') : undefined;
    }
  };

  const { ref, inView } = useInView({
    threshold: 0,
  });
  console.log(inView)

  React.useEffect(() => {
  if (inView && props.showPagination && props?.meta?.hasMoreData) {
    fetchPageData('down');
  }
}, [inView, props.showPagination, props.meta]);

  React.useEffect(() => {
    setData(props.data);
  }, [props.data]);

  React.useEffect(() => {
    setData(sortData(props.data, sort.column, sort.direction));
  }, [sort]);

  const handleSort = (column: string) => {
    if (sort.column === column) {
      setSort({ column, direction: sort.direction === 'ASC' ? 'DESC' : 'ASC' });
    } else {
      setSort({ column, direction: 'ASC' });
    }
  };

  return (
    <div ref={ref}>
     <div className="relative md:rounded-lg position-relative ">
      {props.showHead && (
        <div className="flex lg:block sm:flex-col md:flex-row justify-center items-center  ">
          <MediaQuery minDeviceWidth={768}>
            <Head
              handleSearchSelect={props.handleSearchSelect}
              buttons={props.buttons}
              handleSearch={props.handleSearch}
              handleSort={props.handleSort}
              searchResult={props.searchResult}
              searchDisplayKey={props.searchDisplayKey}
              handleFilter={props.handleFilter}
              filter={props.selectedFilter}
              searchPlaceHolder={props.searchPlaceHolder}
            />
          </MediaQuery>
          <MediaQuery maxDeviceWidth={767}>
            <MobileHead
              handleSearchSelect={props.handleSearchSelect}
              buttons={props.buttons}
              handleSearch={props.handleSearch}
              handleSort={props.handleSort}
              searchResult={props.searchResult}
              searchDisplayKey={props.searchDisplayKey}
              handleFilter={props.handleFilter}
              filter={props.selectedFilter}
              searchPlaceHolder={props.searchPlaceHolder}
            />
          </MediaQuery>
        </div>
      )}
      <div className="flex justify-stretch lg:block w-full text-center ">
        <MediaQuery minDeviceWidth={768}>
          <div className="h-[63px] text-center top-0 left-0 bg-[#044e97] rounded-[10px_10px_0px_0px] mt-[20px] w-full items-center flex  justify-between ">
            <thead className="w-full font-bold text-gray-500 dark:text-gray-400 items-center text-center flex justify-between">
              <tr className="flex justify-evenly">
                {Object.entries(props.head).map((head, i) => (
                  <th scope="col" key={i} className="text-white h-[63px] grid grid-cols-6 xl:pl-[50px] xl:pr-[79px] 2xl:pl-[50px] 2xl:pr-[79px]  3xl:pl-[50px] 3xl:pr-[79px]  4xl:pl-[50px] 4xl:pr-[79px]  biglg:pl-[30px] biglg:pr-[79px]  lg:pl-[5px] md:pl-[1px] bigmd:pl-[5px]" style={{ whiteSpace: 'nowrap' }}>
                    <span className="flex items-center font-semibold xl:text-[14px] 2xl:text-[14px] 3xl:text-[14px] 4xl:text-[14px] biglg:text-[14px] lg:text-[12px] md:text-[13px] bigmd:text-[14px]  ">
                      <span className="md:ml-[0.5em] ">{head[1].title}</span>
                      <span className="md:ml-1 xl:ml-3 cursor-pointer " onClick={() => handleSort(head[0])}>
                        {head[1].icon}
                      </span>
                    </span>

                  </th>
                ))}
              </tr>
            </thead>
          </div>
        </MediaQuery>
      </div>
      <table className="w-full">
        <tbody className="divide-y font-black ">
          <MediaQuery minDeviceWidth={768}>
            <DesktopTableBody data={data} head={props.head} isLoading={props.isLoading} showPagination={false} />
          </MediaQuery>

          <MediaQuery maxDeviceWidth={767}>
            <MobileTableBody
              payHistoryTable={props.payHistoryTable}
              data={data}
              isLoading={props.isLoading}
              showMobileInvoiceTable={props?.showMobileInvoiceTable}
              head={props.head}
              CustomerCard={props.CustomerCard}
              expenseCard={props.expenseCard}
              invoiceCard={props.invoiceCard}
            />
          </MediaQuery>

          <tr>
            <td colSpan={Object.keys(props.head).length}></td>
          </tr>
        </tbody>
      </table>

      {data.length === 0 && !props.isLoading && <Empty />}
      {data.length !== 0 && !props.isLoading && (
        <>
          {!props.hideFloatingScrollButton && (
            <FloatingScrollButton
              className="sticky bottom-8 left-[1099px] z-10"
              action={() => {
                if (props.showPagination && props?.meta?.hasMoreData) {
                  fetchPageData('down');
                }
              }}
              title="Scroll Down"
              direction="down"
              fadeMode={!props?.meta?.hasMoreData}
            />
          )}
        </>
      )}
    </div>
    </div>
  );
};

export { Table };
